import { upperFirst, camelCase } from 'lodash';

var styles = {"alignLeft":"fspiH","textWrapNowrap":"_1yGlk","alignRight":"EgQ0D","alignCenter":"Uxx3-","sizeFullWidth":"xyDaD","renderedInTable":"CQGux","sizeOriginal":"jP8U9","sizeContent":"U7Qhu","sizeSmall":"_7VSjh","sizeSmallCenter":"eIzh-","flex":"M4kp7","atomic":"Wp3I-","anchor":"h6p-2","embed":"tVL-2","horizontalScrollbar":"ofF65","pluginContainerMobile":"Q-D8u"};

const getContainerData = (node) => {
  var _a;
  const data = `${camelCase(node.type)}Data`;
  return (_a = node == null ? void 0 : node[data]) == null ? void 0 : _a.containerData;
};
const getAlignmentClassName = (containerData = {}) => {
  const { alignment } = containerData;
  if (!alignment) {
    return "";
  }
  const key = `align${upperFirst(alignment.toLowerCase())}`;
  return styles[key];
};
const getSizeClassName = (containerData) => {
  const { width } = containerData;
  const { size } = width || {};
  if (!size) {
    return "";
  }
  const key = `size${upperFirst(camelCase(size.toLowerCase()))}`;
  return styles[key];
};
const getTextWrapClassName = (containerData = {}) => {
  const { textWrap } = containerData;
  if (textWrap) {
    return "";
  }
  return styles.textWrapNowrap;
};
const alignmentClassName = (node) => {
  return getAlignmentClassName(getContainerData(node));
};
const sizeClassName = (node) => {
  return getSizeClassName(getContainerData(node) || {});
};
const textWrapClassName = (node) => {
  return getTextWrapClassName(getContainerData(node));
};

export { getSizeClassName as a, getTextWrapClassName as b, alignmentClassName as c, sizeClassName as d, getAlignmentClassName as g, styles as s, textWrapClassName as t };
//# sourceMappingURL=getClassNames-38baac88.js.map
